import OMS from "../assets/images/oms.svg";
import OMSDark from "../assets/images/oms.svg";
import AccountOpening from "../assets/images/Account Opening.svg";
import AccountOpeningDark from "../assets/images/Account Opening.svg";
import FundsApproval from "../assets/images/Funds Approval.svg";
import FundsApprovalDark from "../assets/images/Funds Approval.svg";
import FixSpecifications from "../assets/images/Fix Exchange.svg";
import FixSpecificationsDark from "../assets/images/Fix Exchange.svg";
import GFluxIcon from "../assets/images/gFlux.svg";
import GFluxIconDark from "../assets/images/gFluxDark.svg";
import GRiskIcon from "../assets/images/gRisk.svg";
// eslint-disable-next-line import/no-anonymous-default-export
export default [
  {
    key: 1,
    name: "Account Opening API",
    description: "Onboard new users",
    image: AccountOpening,
    imageDark: AccountOpeningDark,
    route: "/products/account-opening-api",
    link: "https://github.com/VCT-Technologies-LLC/AccountOpeningSample",
    apis: [
      {
        name: "Fund Request",
        endpoint: "/api/fundsapproval/fundrequest",
        method: "POST",
        parameters: {
          FirstName: "string",
          LastName: "string",
          AccountName: "string",
          Account: "number",
          BackOfficeAccountNumber: "string",
          ABA: "number",
          AccountTypeId: "number",
          Address: "string",
          CountryId: "number",
          StateId: "number",
          Apt: "string",
          City: "string",
          ZipCode: "number",
          IsDefault: "boolean",
          Action: "string",
          Requestee: "string",
          Amount: "number",
          RequestTypeId: "number",
          TransactionTypeId: "number",
          PlaidToken: "string",
        },
      },
    ],
    url: "",
  },
  {
    key: 2,
    name: "Funding API",
    description: "Custom workflows",
    image: FundsApproval,
    imageDark: FundsApprovalDark,
    route: "/products/funding-api",
    link: "https://github.com/VCT-Technologies-LLC/FundingSample",
  },
  {
    key: 3,
    name: "Trading API",
    description: "Trade equities, options, monitor positions",
    image: OMS,
    imageDark: OMSDark,
    route: "/products/trading-api-v2.5.1",
    link: "https://github.com/VCT-Technologies-LLC/TradingSample",
  },
  {
    key: 4,
    name: "FIX Specifications",
    description: "Harness the power of our low latency",
    image: FixSpecifications,
    imageDark: FixSpecificationsDark,
    route: "/products/fix-Specifications-v3.5",
    link: "",
  },
  {
    key: 7,
    name: "Corporate Actions API",
    description: "Real-time data streaming",
    image: GFluxIconDark,
    imageDark: GFluxIcon,
    imageStyle: { width: "60px", height: "auto", position:"relative", top:"0px" },
    route: "/products/corporate-actions-api",
    link: "",
  },
  {
    key: 8,
    name: "Risk & Margin API",
    description: "Risk profiles and margin controls",
    image: GRiskIcon,
    imageDark: GRiskIcon,
    imageStyle: { width: "80px", height: "auto", position:"relative", top:"15px" },
    route: "/products/risk-margin-api",
    link: "",
  },
];
